import { Component, OnInit } from '@angular/core';
import { ClientService } from "./";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Utils } from '../core/utils';
import { switchMap, of, catchError } from 'rxjs';
import { AlertService } from '../shared/services/alert.service';



@Component({
  selector: 'app-client-component',
  templateUrl: './client.component.html',
  standalone: false
})
export class ClientComponent implements OnInit{
  
  
  public clientID = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private readonly alertService: AlertService,
    private clientService: ClientService) {
  }

  ngOnInit() {

    
      this.route.paramMap.pipe(
        switchMap((params: ParamMap) => {
          this.clientID = Number( params.get('ID'));

          if ((this.clientID >0)
            && (this.clientService.currentClient == null
              || this.clientService.currentClient.ID != this.clientID)) {
          console.debug('Loading client '+ this.clientID);
          return this.clientService.getClientInfo(this.clientID );

          
        }else {
            return of(undefined); 
          }
        })
      ).pipe(catchError(error => {
          this.alertService.error(Utils.getAjaxError(error));
          return of(undefined);
        }))
    .subscribe(client => {
        //console.info('Loaded client ' , client);
      });  

    


  
  }

}
